var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_8256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59433 7.94141L9.23069 4.30504V3.78556L5.59433 0.149199L5.08284 0.668679L8.09583 3.68167H0.503418V4.40894H8.09583L5.08284 7.42193L5.59433 7.94141Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_8256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 8,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 8.04492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowStroke);
export default __webpack_public_path__ + "static/media/right_arrow_stroke.d334ad2a9bc3c01a2e8c6e8cb4d70a77.svg";
export { ForwardRef as ReactComponent };